import auth from '@/router/auth'
import PromotionIndex from '@/components/facults/Index'
import PromotionCreate from '@/components/facults/Create'
import PromotionUpdate from '@/components/facults/Update'
import PromotionShow from '@/components/facults/Show'

export default [
  {
    path: '/facults',
    name: 'facults-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/facults/create',
    name: 'facults-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/facults/update/:facult_id',
    name: 'facults-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/facults/show/:facult_id',
    name: 'facults-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/facults/router.js